// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ryBn","col":"styles_col__6a3Im"};